// Copyright (c) 2026 Joshua S. Plaza. All rights reserved.

import React, { Suspense } from 'react';
import ErrorBoundary from './ErrorBoundary';
import PageLoader from './PageLoader';

/**
 * Wraps a route or route group with ErrorBoundary + Suspense.
 * If a page crashes, the ErrorBoundary catches it so other routes still work.
 * If a lazy chunk is still loading, the Suspense fallback shows a spinner.
 */
const PageWrapper = ({ children }) => (
  <ErrorBoundary>
    <Suspense fallback={<PageLoader />}>
      {children}
    </Suspense>
  </ErrorBoundary>
);

export default PageWrapper;
